import React, {Component} from "react";
import {Col, Container, Row} from "reactstrap";
import {Link} from "react-router-dom";
import logodark from "../assets/images/logo-main.jpg";

class SalesConfirmation extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        document.body.classList.add('auth-body-bg');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-body-bg');
    }

    render() {
        return (
            <React.Fragment>
                <Container fluid className="p-0">
                    <Row className="no-gutters">
                        <Col lg={5}>
                            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                <div className="w-100">
                                    <Row className="justify-content-center">
                                        <Col lg={9}>
                                            <div>
                                                <div className="text-center">
                                                    <div>
                                                        <Link to="/" className="logo">
                                                            <img src={logodark} height="60" alt="logo" />
                                                        </Link>
                                                    </div>

                                                    <h4 className="badge badge-soft-success font-size-18">Demo Request Successfully Sent !</h4>
                                                    <p className="text-muted">
                                                        We are excited to take this next step with you.
                                                    </p>
                                                </div>
                                                <div className="mt-5 text-center">
                                                    <p>
                                                        Have any questions ?{' '}
                                                        {' '}
                                                        Contact CloudNovaTech{' '}
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                        <Col lg={7}>
                            <div className="authentication-confirmation-bg">
                                {/* bg-overlay */}
                                <div className=""></div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </React.Fragment>
        );
    }
}
export default SalesConfirmation;
